import _get from "lodash/get";
import _isEmpty from "lodash/isEmpty";
import { AnyAction } from "redux";
import * as AT from "./actionTypes";
import { EmployeeInfoState } from "../../../../models/state";
import { fulfilled } from "../../app/utils";
import * as CheckoutAT from "../../checkout/state/actionTypes";

const initialState: EmployeeInfoState = {
    employeeInfo: {
        address: {
            city: "",
            street: "",
            postcode: "",
        },
        phonenumber: "",
        email: "",
        firstName: "",
        lastName: "",
    },
    submitEmailSuccess: false,
    allowedToProceed: false,
    submitSubscriptionDetailsSuccess: false,
};

const reducer = (state = initialState, action: AnyAction): EmployeeInfoState => {
    switch (action.type) {
        case fulfilled(CheckoutAT.CHECKOUT_SET_PERSONAL_DETAILS):
            return {
                ...initialState,
                submitEmailSuccess: _get(action, "payload.success", false),
            };
        case fulfilled(AT.ONBOARDING_SET_SUBSCRIPTION_DETAILS):
            return {
                ...initialState,
                submitSubscriptionDetailsSuccess: _get(action, "payload.success", false),
            };
        case fulfilled(AT.ONBOARDING_VERIFY_UPDATED_NAME):
            return {
                ...initialState,
                allowedToProceed: !!action.payload.allowedToProceed,
                employeeInfo: !_isEmpty(action.payload.employeeInfo) ? action.payload.employeeInfo : state.employeeInfo,
            };
        case fulfilled(CheckoutAT.CHECKOUT_SET_SELECTED_PHONE_NUMBER):
            return {
                ...initialState,
                allowedToProceed: !!action.payload.allowedToProceed,
            };
        case fulfilled(CheckoutAT.CHECKOUT_CHECK_NEW_MEMBER_PHONE_NUMBER):
            return {
                ...initialState,
                allowedToProceed: !!action.payload.allowedToProceed,
            };
        default:
            return state;
    }
};

export default reducer;
